import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import {
  DialogContentBase, DialogModule, DialogRef,
  KENDO_DIALOGS,
  ActionsLayout
} from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { PermissionType } from '../../../models/models.lib';
import { CasiCloseOptions, FormModes } from '../../../common/constants.lib';
import { AutoFocusDirective } from '../../../directives/auto-focus.directive';
import { LoggerService } from '../../../shared/logger.service';

@Component({
  selector: 'casi-edit-permission-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    RouterLink, RouterLinkActive,
    DialogModule,
    EditorModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective,
    KENDO_DIALOGS
  ],
  templateUrl: './edit-permission-modal.component.html',
  styleUrl: './edit-permission-modal.component.scss'
})
export class EditPermissionModalComponent extends DialogContentBase implements OnInit {

  private _permission: PermissionType | undefined;

  @Input() title: string = 'Title Not Set';

  @Input({ required: true }) set permission(val: PermissionType) {
    this._permission = val;
    this.permissionForm.patchValue(this._permission);
  }
  get permission(): PermissionType | undefined {
    return this._permission;
  };

  private _mode: FormModes = FormModes.NOTSET;
  @Input({ required: true }) set mode(val: FormModes) {
    this._mode = val;
  }
  get mode(): FormModes {
    return this._mode;
  };

  permissionForm: FormGroup;

  constructor(
    public override dialog: DialogRef,
    private fb: FormBuilder,
    private logger: LoggerService,
  ) {
    super(dialog);
    this.permissionForm = this.fb.group(
      {
        id: [null, []],
        entity: [null, [Validators.required]],
        action: [null, [Validators.required]]
      }
    );
  }

  //#region Form

  get f() {
    return this.permissionForm.controls;
  }
  get entity() {
    return this.permissionForm.get('entity');
  }
  get action() {
    return this.permissionForm.get('action');
  }

  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  public onCancelAction(): void {
    this.logger.debug(`onCancelAction...`);
    this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }

  public onSaveAction(): void {
    this.logger.debug(`onSaveAction...`, this.permissionForm.value);
    if (this.permissionForm.status !== 'INVALID')
      this.dialog.close({ text: CasiCloseOptions.Saved });
  }
}

